/* eslint-disable */
import { createStore } from 'vuex'
import moment from "moment"

const state = {
    auth: null,
    clientIP: null,
    user: null,
    onLoad: false,
    searchFilters: {
        query: null,
        documentId: "",
        nomrevue: [],
        motcle: [],
        rubrique: [],
        specialite: [],
        annee_debut: null,
        annee_fin: null,
        annee_parution: null,
        num_revue: null,
        page_debut: null,
        sort: "",
        offset: 0
    },
    abonnements: [],
    publications: null,
    refreshTimer: null,
}

function parseAbonnement(abonnements)
{
    let revues = [];
    let filters_abonnements = [];
    const now = moment();
    const abos = Object.values(abonnements);
    if (abos.length > 0) {
        // Remove Duplicate
        for (let i = 0; i < abos.length; i++) {
            const item = abos[i];
            if (revues.indexOf(item.key) === -1) {
                revues.push(item.key);
                filters_abonnements.push(item);
            }
        }

        for (let i = 0; i < filters_abonnements.length; i++) {
            const element = abos[i];
            const period = element.period;
            element.inProgress = false;
            if (period.length > 0) {
                for (let j = 0; j < period.length; j++) {
                    const el = period[j];
                    let start = moment(el.start_date);
                    let end = moment(el.end_date);
                    if(start.isBefore(now) && end.isAfter(now)) {
                        element.inProgress = true
                    }
                }
            }
        }
        return filters_abonnements;
    }
}

const getters = {
    getClientIP(state) {
        return state.clientIP
    },
    isAuthenticated ({ auth, user }) {
        return auth && auth.expires && auth.expires > new Date() && user
    },
    getProfile(state) {
        return state.user
    },
    getAbonnements(state) {
        return state.abonnements
    },
    getAbonnementsStartDates(state) {
        let values = [];
        let years = [];

        Object.values(state.abonnements).forEach((el) => {
            let dates = el.period.map(a => a.start_date);
            values = values.concat(dates);
        });

        values.forEach(value => {
            let year = moment(value).format('YYYY');
            if (years.indexOf(year) == -1) {
                years.push(year);
            }
        });

        return years;
    },
    getAbonnementsEndDates(state) {
        let values = [];
        let years = [];

        Object.values(state.abonnements).forEach((el) => {
            let dates = el.period.map(a => a.end_date);
            values = values.concat(dates);
        });

        values.forEach(value => {
            let year = moment(value).format('YYYY');
            if (years.indexOf(year) == -1) {
                years.push(year);
            }
        });

        return years;
    },
    getStartDatesRevue: (state) => (abo) => {
        // const abonnement = state.abonnement.filter(f => f.key === key);
        // console.log(abo)
        if (!abo.isAbonne) {
            abo.period.forEach((item) => {
                //console.log(item)
            })
        }
    },
    getSearchFilters(state) {
        return state.searchFilters
    },
    getPublications(state) {
        return state.publications;
    }
}

const actions = {
    setClientIP({ commit }, data) {
        commit('SET_CLIENTIP', data)
    },
    setToken4D({ commit }, data) {
        commit('SET_TOKEN4D', data)
    },
    setAuthFromApi({ dispatch, commit, state }, data) {
        return new Promise((resolve) => {
            if (data['token']) {
                this.$app.config.globalProperties.$api.postAuth(data).then(({ data }) => {
                    if(data.code && data.code != '200'){
                        dispatch('setLogout')
                        return
                    }

                    commit('SET_AUTH', data)
                    dispatch('startTokenRefreshTimer');
                    resolve();

                    this.$app.config.globalProperties.$api.postMe(state.auth.token).then(data => {
                        dispatch('setUser', data.data.data)
                        resolve();
                    })
                    .catch( (error) => {
                        dispatch('setLogout')
                        resolve();
                    })
                })
                .catch( (error) => {
                    dispatch('setLogout')
                    resolve();
                })
            } else {
                this.$app.config.globalProperties.$api.postLogin(data).then(({ data }) => {
                    if (data.code && data.code != '200') {
                        dispatch('setLogout')
                        return
                    }

                    commit('SET_AUTH', data)
                    dispatch('startTokenRefreshTimer');
                    resolve();

                    // Retrieving user information
                    this.$app.config.globalProperties.$api.postMe(state.auth.token).then(data => {
                        dispatch('setUser', data.data.data);
                        resolve();
                    })
                    .catch((error) => {
                        dispatch('setLogout')
                        resolve();
                    })
                })
                .catch((error) => {
                    dispatch('setLogout')
                    resolve();
                })
            }
        })
    },
    setAuthFromApiAutoConnect ({ dispatch, commit, state }, data) {
        return new Promise((resolve) => {
            this.$app.config.globalProperties.$api.postConnnect(data).then(({ data }) => {
                if(data.code && data.code != '200'){
                    dispatch('setLogout')
                    return
                }

                commit('SET_AUTH', data);
                dispatch('startTokenRefreshTimer');
                resolve();

                // Retrieving user information
                this.$app.config.globalProperties.$api.postMe(state.auth.token)
                .then((data) => {
                    dispatch('setUser', data.data.data);
                    resolve();
                })
                .catch((error) => {
                    dispatch('setLogout')
                })
            })
            .catch((error) => {
                dispatch('setLogout')
                resolve();
            })
        })
    },
    setLogout({ commit }) {
        commit('SET_LOGOUT')
    },
    setLogoutUser({ commit }) {
        commit('SET_LOGOUT_USER')
    },
    setUser({ commit }, data) {
        commit('SET_USER', data)
    },
    setOnLoad({ commit }, data) {
        commit('SET_ON_LOAD', data)
    },
    setSearchFilters({ commit }, data) {
        commit('SET_SEARCH_FILTERS', data)
    },
    setPublications({ commit }, data) {
        commit('SET_PUBLICATION', data)
    },
    async refreshToken({commit, state, dispatch}) {
        if (state.auth && state.auth.token){
            try{
                const { data } = await this.$app.config.globalProperties.$api.postRefresh(state.auth.token);
                if (data.code && data.code != '200') {
                    dispatch('setLogout');
                    return;
                }
                commit('SET_AUTH', data);
            } catch (error) {
                dispatch('setLogout');
            }
        }
    },
    startTokenRefreshTimer({ state, dispatch }) {
        // Nettoyer tout ancien intervalle s'il existe
        if (state.refreshTimer) clearInterval(state.refreshTimer);

        // Démarrer un nouvel intervalle
        state.refreshTimer = setInterval(() => {
            const now = new Date();
            const expires = new Date(state.auth.expires);
            if (expires - now < 300 * 1000) {
                dispatch('refreshToken');
            }
        }, 60000);
    },
}

const mutations = {
    SET_CLIENTIP(state, data) {
        state.clientIP = data
    },
    SET_TOKEN4D(state, data) {
        state.token4D = data
    },
    SET_AUTH(state, auth) {
        const expires = new Date()
        expires.setSeconds(expires.getSeconds() + (auth.expires_in || 3600))

        auth.token = auth.access_token
        delete auth.access_token

        state.auth = {
            ...auth,
            expires
        }
    },
    SET_USER(state, data) {
        state.user = data
        state.abonnements = parseAbonnement(data.abonnements || []);
    },
    SET_LOGOUT(state) {
        if(state.auth){
            this.$app.config.globalProperties.$api.postLogout(state.auth).then( (data) => {
                this.$app.$cookies.remove('token')
                state.auth = null
                state.user = null
                if (state.refreshTimer) {
                    clearInterval(state.refreshTimer);
                    state.refreshTimer = null;
                }
                this.$app.config.globalProperties.$router.push({ name: 'login' })
            })
        } else {
            this.$app.config.globalProperties.$cookies.remove('token')
            state.auth = null
            state.user = null
            if (state.refreshTimer) {
                clearInterval(state.refreshTimer);
                state.refreshTimer = null;
            }
            this.$app.config.globalProperties.$router.push({ name: 'login' })
        }
    },
    SET_LOGOUT_USER(state) {
        if(state.auth){
            this.$app.config.globalProperties.$api.postActivity({
                token: this.$app.config.globalProperties.$cookies.get('token'),
                category: 'déconnexion',
                action: 'se deconnecter',
                label: 'user déconnexion'
            });
            this.$app.config.globalProperties.$api.postLogout(state.auth).then( (data) => {
                this.$app.$cookies.remove('token')
                state.auth = null
                state.user = null
                if (state.refreshTimer) {
                    clearInterval(state.refreshTimer);
                    state.refreshTimer = null;
                }
                this.$app.config.globalProperties.$router.push({ name: 'login' })
            })
        } else {
            this.$app.config.globalProperties.$cookies.remove('token')
            state.auth = null
            state.user = null
            if (state.refreshTimer) {
                clearInterval(state.refreshTimer);
                state.refreshTimer = null;
            }
            this.$app.config.globalProperties.$router.push({ name: 'login' })
        }
    },
    SET_ON_LOAD(state, data) {
        state.onLoad = data
    },
    SET_SEARCH_FILTERS(state, data) {
        state.searchFilters = data
    },
    SET_PUBLICATION(state, data) {
        state.publications = data
    },
}

export default createStore({
    state,
    getters,
    actions,
    mutations
})